// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1pvk9","SiteInfo":"Footer_SiteInfo__nZ49z","Info":"Footer_Info__jfiFm","About":"Footer_About__2nQuO","Col":"Footer_Col__2A6K0","Logo":"Footer_Logo__NjEha"};